import { useColorMode, useColorStyle } from '@tonic-one/react';

const useTextButtonStyle = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const colorModeStyle = (
    {
      light: {
        _hover: {
          bg: colorStyle.background.tertiary,
        },
      },
      dark: {
        _hover: {
          bg: colorStyle.background.tertiary,
        },
      },
    } as any
  )[colorMode];

  return {
    ...colorModeStyle,
  };
};
export { useTextButtonStyle };
